import BetterClipboard from './BetterClipboard';
import ImageResize from './ImageResize';

export { BetterClipboard, ImageResize };

export const modules = [BetterClipboard, ImageResize];
